var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { ScrollArrowRight } from "../../../assets/svg/ScrollArrowRight";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var ArrowRight = function (props) {
    return React.createElement(SvgButton, __assign({ svg: ScrollArrowRight, name: IdStyles.ScrollArrowRight }, props));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ArrowRight.tsx
// module id = 2784
// module chunks = 3